import { useNavigate } from "react-router-dom";
import { useCookieStore } from "../../store/cookiestore";
import { useTranslation } from "react-i18next";
export default function CookieBanner() {
  const { t } = useTranslation();
  const { cookieConsent, acceptCookies, rejectCookies } = useCookieStore();

  // Already decided — don't show banner
  if (cookieConsent !== null) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 md:px-6 md:pb-6">
      <div className="max-w-4xl mx-auto bg-[#02160e] border border-green-900/40 rounded-2xl px-5 py-5 shadow-2xl shadow-black/60 backdrop-blur-sm">
        <div className="flex flex-col md:flex-row md:items-center gap-4">

          {/* TEXT */}
          <div className="flex-1">
            <p className="text-sm font-semibold text-white mb-1">
              {t("cookies.title")}
            </p>
            <p className="text-xs text-gray-400 leading-relaxed">
              {t("cookies.description")}{" "}
              <a
                href="/tickets-store/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-400/80 hover:text-green-400 underline transition"
              >
                {t("cookies.policy")}
              </a>
              .
            </p>
          </div>

          {/* BUTTONS */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={rejectCookies}
              className="px-4 py-2 rounded-xl border border-green-900/50 text-gray-400 text-xs tracking-widest uppercase hover:border-green-700/50 hover:text-white transition"
            >
              {t("cookies.reject")}
            </button>
            <button
              onClick={acceptCookies}
              className="px-4 py-2 rounded-xl bg-green-500 text-black text-xs font-bold tracking-widest uppercase hover:bg-green-400 transition"
            >
              {t("cookies.accept")}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
